<div class="page-content container">
    <div class="login shadow-sm">
        <div class="login-header">
            <!-- <span>Нова лозинка</span> -->
            <span>{{ translationManager.getTranslation('Нова лозинка') }}</span>
        </div>
        <div class="alert alert-info">
            <!-- <span><i class="fa fa-info-circle"></i>Молимо унесите нову лозинку за пријаву на систем</span> -->
            <span><i class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Молимо унесите нову лозинку за пријаву на систем') }}</span>
        </div>
        <div class="login-body">

            <div class="page-part">
              <div class="app-form-element" [ngClass]="{'app-form-element-error': form.elements['username'].error.required || form.elements['username'].error.invalid }">
                <!-- <label>Нова лозинка</label> -->
                <label>{{ translationManager.getTranslation('Корисничко име') }}</label>
                <div class="app-form-element-content">
                  <input name="username" [(ngModel)]="form.elements['username'].value" maxlength="500" (keyup.enter)="changePassword()">
                </div>
                <div class="app-form-element-error-panel">
                  <!-- <span *ngIf="form.elements['newpassword'].error.required"><i class="fas fa-times-circle"></i>Поље је обавезно за унос</span> -->
                  <span *ngIf="form.elements['username'].error.required"><i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
                </div>
              </div>
            </div>

            <div class="page-part">
              <div class="app-form-element" [ngClass]="{'app-form-element-error': form.elements['oldpassword'].error.required || form.elements['oldpassword'].error.invalid }">
                <!-- <label>Нова лозинка</label> -->
                <label>{{ translationManager.getTranslation('Стара лозинка') }}</label>
                <div class="app-form-element-content">
                  <input type="password" name="oldpassword" [(ngModel)]="form.elements['oldpassword'].value" maxlength="500" (keyup.enter)="changePassword()">
                </div>
                <div class="app-form-element-error-panel">
                  <!-- <span *ngIf="form.elements['newpassword'].error.required"><i class="fas fa-times-circle"></i>Поље је обавезно за унос</span> -->
                  <span *ngIf="form.elements['oldpassword'].error.required"><i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
                </div>
              </div>
            </div>

            <div class="page-part">
                <div class="app-form-element" [ngClass]="{'app-form-element-error': form.elements['newpassword'].error.required || form.elements['newpassword'].error.invalid }">
                    <!-- <label>Нова лозинка</label> -->
                    <label>{{ translationManager.getTranslation('Нова лозинка') }}</label>
                    <div class="app-form-element-content">
                        <input type="password" name="newpassword" [(ngModel)]="form.elements['newpassword'].value" maxlength="500" (keyup.enter)="changePassword()">
                    </div>
                    <div class="app-form-element-error-panel">
                        <!-- <span *ngIf="form.elements['newpassword'].error.required"><i class="fas fa-times-circle"></i>Поље је обавезно за унос</span> -->
                        <span *ngIf="form.elements['newpassword'].error.required"><i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
                    </div>
                </div>
            </div>
            <div class="page-part">
                <div class="app-form-element" [ngClass]="{ 'app-form-element-error': form.elements['confirmpassword'].error.required || form.elements['confirmpassword'].error.invalid || passwordNotMatch }">
                    <!-- <label>Поновите лозинку</label> -->
                    <label>{{ translationManager.getTranslation('Поновите лозинку') }}</label>
                    <div class="app-form-element-content">
                        <input type="password" name="confirmpassword" [(ngModel)]="form.elements['confirmpassword'].value" maxlength="500" (keyup.enter)="changePassword()">
                    </div>
                    <div class="app-form-element-error-panel">
                        <!-- <span *ngIf="form.elements['confirmpassword'].error.required"><i class="fas fa-times-circle"></i>Поље је обавезно за унос</span> -->
                        <span *ngIf="form.elements['confirmpassword'].error.required"><i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
                        <!-- <span *ngIf="passwordNotMatch"><i class="fas fa-times-circle"></i>Лозинке се не подударају</span> -->
                        <span *ngIf="passwordNotMatch"><i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Лозинке се не подударају') }}</span>
                    </div>
                </div>
            </div>

            <div class="app-form-element-buttons">
                <!-- <button class="btn btn-success" (click)="resetPassword()"><i class="fa fa-check mr-2"></i>Ресетуј лозинку</button> -->
                <button class="btn btn-success" (click)="changePassword()"><i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Ресетуј лозинку') }}</button>
            </div>
        </div>
    </div>
</div>


